/** Build time-synced segments for audio review (CRT-01-AC2) */

export const buildSyncSegments = (content, durationSeconds = 0, apiSegments = null) => {
  if (Array.isArray(apiSegments) && apiSegments.length > 0) {
    return apiSegments.map((segment, index) => ({
      id: segment.id ?? index,
      text: segment.text || segment.content || '',
      start: Number(segment.start_time_seconds ?? segment.start ?? 0),
      end: Number(segment.end_time_seconds ?? segment.end ?? segment.start_time_seconds ?? 0),
      speaker: segment.role_name || segment.speaker_label || segment.speaker || null,
      confidence_score: segment.confidence_score ?? null,
    }));
  }

  if (!content || !content.trim()) return [];

  const paragraphs = content
    .split(/\n+/)
    .map((p) => p.trim())
    .filter(Boolean);

  if (paragraphs.length === 0) return [];

  const totalWords = paragraphs.reduce(
    (sum, p) => sum + p.split(/\s+/).filter(Boolean).length,
    0
  );
  const safeDuration = durationSeconds > 0 ? durationSeconds : paragraphs.length * 15;

  let cursor = 0;
  return paragraphs.map((text, index) => {
    const words = text.split(/\s+/).filter(Boolean).length;
    const ratio = totalWords > 0 ? words / totalWords : 1 / paragraphs.length;
    const segmentDuration = ratio * safeDuration;
    const start = cursor;
    const end = cursor + segmentDuration;
    cursor = end;
    return { id: index, text, start, end, speaker: null };
  });
};

export const findActiveSegmentIndex = (segments, currentTime) => {
  if (!segments?.length) return -1;
  const index = segments.findIndex(
    (seg) => currentTime >= seg.start && currentTime < seg.end
  );
  if (index >= 0) return index;
  if (currentTime >= segments[segments.length - 1].end) {
    return segments.length - 1;
  }
  return 0;
};

export const formatPlaybackTime = (seconds) => {
  if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
};

export const resolveAudioUrl = (item, apiBaseUrl) => {
  const candidates = [
    item?.audio_url,
    item?.audio_file_url,
    item?.file_url,
    item?.recording_url,
    item?.metadata?.audio_url,
    item?.metadata?.audio_file_url,
  ].filter(Boolean);

  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.startsWith('http')) {
      return candidate;
    }
  }

  const path =
    item?.audio_file_path ||
    item?.audio_path ||
    item?.metadata?.audio_file_path;

  if (path && typeof path === 'string') {
    if (path.startsWith('http')) return path;
    const base = (apiBaseUrl || '').replace(/\/api\/v1\/?$/, '');
    return `${base}${path.startsWith('/') ? path : `/${path}`}`;
  }

  if (item?.id && apiBaseUrl) {
    const url = `${apiBaseUrl.replace(/\/$/, '')}/transcriptions/${item.id}/audio`;
    const token = typeof localStorage !== 'undefined'
      ? localStorage.getItem('courtscribe_token')
      : null;
    if (token) {
      return `${url}?token=${encodeURIComponent(token)}`;
    }
    return url;
  }

  return null;
};
